(function () {
  document.querySelectorAll('[data-video-lola]').forEach(function (section) {
    initResponsiveMedia(section);
  });

  // Same lazy-loading pattern as heromain-lola: four possible <video>
  // sources (Desktop/Mobile × Day/Night) sit inertly inside <template>
  // tags — content inside a <template> is never parsed as live DOM and
  // its resources are never fetched by the browser, unlike a hidden
  // element (display:none still downloads). This checks the current
  // viewport width AND the current theme BEFORE any of the four is
  // ever inserted, and only clones/inserts the one that actually
  // matches — so only one video ever downloads, regardless of screen
  // size or theme. A MutationObserver reacts live if the visitor
  // toggles day/night without a page reload.
  function initResponsiveMedia(section) {
    var mediaContainer = section.querySelector('[data-video-lola-media]');
    var templates = {
      desktop: {
        day: section.querySelector('template[data-video-lola-media="desktop"][data-video-lola-theme="day"]'),
        night: section.querySelector('template[data-video-lola-media="desktop"][data-video-lola-theme="night"]')
      },
      mobile: {
        day: section.querySelector('template[data-video-lola-media="mobile"][data-video-lola-theme="day"]'),
        night: section.querySelector('template[data-video-lola-media="mobile"][data-video-lola-theme="night"]')
      }
    };

    if (
      !mediaContainer ||
      !templates.desktop.day ||
      !templates.desktop.night ||
      !templates.mobile.day ||
      !templates.mobile.night
    ) {
      return;
    }

    var breakpoint = window.matchMedia('(min-width: 750px)');
    var liveEl = null;
    var lastKey = null;

    function currentTheme() {
      return document.documentElement.getAttribute('data-theme') === 'night' ? 'night' : 'day';
    }

    function insertWinner() {
      var widthKey = breakpoint.matches ? 'desktop' : 'mobile';
      var themeKey = currentTheme();
      var key = widthKey + '-' + themeKey;

      if (key === lastKey) return;

      var winningTemplate = templates[widthKey][themeKey];

      if (liveEl) {
        var oldVideo = liveEl.querySelector('video');
        if (oldVideo) oldVideo.pause();
        liveEl.remove();
      }

      var fragment = winningTemplate.content.cloneNode(true);
      var wrapper = document.createElement('div');
      wrapper.style.display = 'contents';
      wrapper.appendChild(fragment);

      // Inserted right before the templates themselves, so it stays
      // beneath the overlay (a later sibling) in paint order.
      mediaContainer.insertBefore(wrapper, templates.desktop.day);
      liveEl = wrapper;
      lastKey = key;

      var newVideo = wrapper.querySelector('video');
      if (newVideo) {
        newVideo.play().catch(function () {
          /* Autoplay can still be blocked in some contexts — fail
             silently. */
        });
      }
    }

    breakpoint.addEventListener('change', insertWinner);

    // header-lola's theme toggle sets data-theme directly on <html> —
    // no custom event is dispatched anywhere for that change, so a
    // MutationObserver is the reliable way to react to it live.
    var themeObserver = new MutationObserver(insertWinner);
    themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    insertWinner();
  }
})();